import React, { useEffect, useRef, useState } from "react";
import CustomButton from "../CustomButton/CustomButton";
import { MdAddCircle } from "react-icons/md";
import { warnToast } from "../../../utils/toasts";
import { BiLinkExternal } from "react-icons/bi";

const FileInputBasic = ({
  variant = "traditional",
  buttonVariant = "outlined",
  label = "Upload File",
  setSelectedFiles = () => {},
  icon = null,
  accept = "*",
  size = 0,
  sizeVariant = "MB",
  name = null,
  multipleFiles = false,
  clearFiles,
  fileName = null,
  fileType = "all",
}) => {
  const fileSizeRestrict = size * (sizeVariant === "MB" ? 1024 * 1024 : 1024);
  const [files, setFiles] = useState({});
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };
  const fileTypeMap = {
    image: "image/*",
    video: "video/*",
    pdf: ".pdf",
    all: "*", // Default: allows all file types
  };

  const _accept = fileTypeMap[fileType] || "*";
  useEffect(() => {
    if (clearFiles) {
      setFiles({});
      setSelectedFiles([]);
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Reset input field
      }
    }
  }, [clearFiles]);
  const onChange = (event) => {
    if (size) {
      const isLargerThen2mb = Object.values(event.target.files).some(
        (file) => file.size > fileSizeRestrict
      );
      if (isLargerThen2mb) {
        warnToast(`Please choose ${size}${sizeVariant} files`);
        return;
      }
    }
    setSelectedFiles(event.target.files, event);
    setFiles(event.target.files);
  };

  const getFileName = () => {
    if (!fileName && !files) return "";

    if (Array.isArray(fileName)) {
      return fileName.map((file) => file.name).join(", ");
    }

    if (typeof fileName === "object" && fileName !== null) {
      return Object.values(fileName)
        .map((file) => file.name)
        .join(", ");
    }

    if (typeof fileName === "string") {
      // Extract filename from URL
      const urlParts = fileName.split("/");
      const filename = urlParts[urlParts.length - 1];
      return filename || "";
    }

    return Object.values(files)
      .map((file) => file.name)
      .join(", ");
  };

  const _files = Object.values(fileName || files);
  const isExistingFile = (file) => typeof file === "string";

  return (
    <>
      <input
        name={name}
        accept={_accept}
        id="fileInput"
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={onChange}
        multiple={multipleFiles}
      />

      {variant === "traditional" ? (
        <div className="flex flex-col gap-2">
          {/* Bordered Div for Selected File Name */}
          <div className="border border-gray-300 rounded-md h-full  min-h-[40px] flex items-center justify-between px-3 overflow-hidden">
            <span className="text-xs pr-2" style={beginningEllipsisStyle}>
              {getFileName() ||
                (size
                  ? `Max ${size}${sizeVariant} file size`
                  : "No Files Selected")}
            </span>
            <div className="flex justify-between h-full items-center border-l-2 border-gray-300 pl-2">
              <label htmlFor="fileInput">
                <button
                  className="rounded-md text-sm whitespace-nowrap"
                  onClick={handleClick}
                  type="button"
                >
                  {label}
                </button>
              </label>
            </div>
          </div>

          {/* Upload Button Aligned at the End */}
          {/* <div className="flex justify-between items-center border-l-2 border-gray-400 pl-2">
            <label htmlFor="fileInput">
              <button
                className="rounded-md border py-1 px-2 text-sm"
                onClick={handleClick}
              >
                {label}
              </button>
            </label>
          </div> */}
        </div>
      ) : (
        <CustomButton
          label={label}
          variant={buttonVariant}
          startIcon={icon || <MdAddCircle />}
          onClick={handleClick}
        />
      )}
    </>
  );
};

export default FileInputBasic;

const beginningEllipsisStyle = {
  display: "inline-block",
  // maxWidth: "200px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  direction: "rtl",
  textAlign: "left",
};
